import Vue from 'vue'
import $store from '@/code-lab/store'




let storeIns = {}
export class LoginQuick  {
    constructor (quickStore) {
        this.b$ = new Vue().b$
        this.$store = $store
        if (quickStore) {
            storeIns = quickStore
        }
        return this.single()
    }

    single () {
        if (!LoginQuick.instance) {
            LoginQuick.instance = this 
        }
        return LoginQuick.instance
    }

    async get_robot_family () {
        const { serialNumber, clientId, to } = storeIns
        const data = {
            cmd: "get_robot_family",
            data: {
                clientId: serialNumber,
                to: to || clientId,
                from: serialNumber,
                query: {
                    limit: 10,
                    page: 1
                }
            }
        }
        this.b$.send('quick', data, response => {
            console.log(response, 'get_robot_family')
        },
        {
            eventName: 'ws.cmd.update_robot_family',
            callBack: response => {
                console.log(response)
                this.$store.commit('SET_ROBOT_FAMILIES', response.data.filter(item => (item.nickName || item.name) && item.faceId && item.faceId > 0).map(item => {
                    return {
                        value: item.nickName,
                        label: item.nickName || item.name || "",
                        thumb: item.avatarPath
                      }
                  }))
            }
        })
    }
    async update_contact_list(to) {
      this.b$.assignment("quick", { to }, "store");
      this.get_robot_family();
      this.testVersionHandle(to)
    }

    getCallUpdateOfBackEnd (response) {
        if (!response) {
            this.b$.catchCallBack('quick', 'ws.cmd.update_contact_list', this.getCallUpdateOfBackEnd.bind(this))
        } else {
            const { clientNames = [], list = [] } = response.data
            console.log('this.getCallUpdateOfBackEnd', response, list)
            const robotId = list.find(o => o.indexOf('0-') === 0) || ''
            this.b$.assignment("quick", { robotId }, "store");
            !robotId ?  this.b$["quick"].h$.collect("robotCode", 999) :  this.b$["quick"].h$.collect("robotCode", 1)
            let connectionDevices = clientNames.filter(fo => fo.clientId === robotId).map(item => {
                return {
                    ...item,
                    sn: item.clientId.split("-").pop()
                }
            })
            if(connectionDevices.length === 0){
                connectionDevices = [{ clientName: robotId || '000-test', clientId: robotId , sn: robotId.split("-").pop()}]
            }
            this.$store.commit("quickConnection/connectDevices", connectionDevices);
            this.update_contact_list(robotId);
            this.$store.dispatch("quickConnection/getRobotInfo", {to: robotId})
            setTimeout(() => this.$store.commit("quickConnection/closeState", false), 1000)
        }
    }
    testVersionHandle (to) {
        console.log('testVersionHandle', to)
        this.b$.send('quick', {
            cmd: 'get_mc_info',
            data: { to }
        }, response => {
            console.log(response, 'response')
        })
    }

    async loginIn () {
      const { randomCode, serialNumber } = storeIns || {}
      const data = { randomCode, serialNumber };
      this.b$.send("quick", { cmd: "login", data }, res => {
          console.log('login ->', this.b$)
          const resMsg = res
          const clientId = resMsg && resMsg.data && resMsg.data.clientId || false
          clientId && this.b$.assignment("quick", { clientId }, "store")
          this.$store.commit("handleConnectGolbalState", 2)
          localStorage.setItem("robotLastSixCode", serialNumber)
          this.$store.commit("quickConnection/closeState", true)
          this.getCallUpdateOfBackEnd()
          setTimeout(() => this.$store.commit("quickConnection/closeState", false), 1000)
        })
    }
}